const KOREA_CATEGORY = '10';
const ELEMENTARY_SCHOOL_TYPE = '1';
const MATH_SUBJECT = '02';

/**
 * 문제 은행 노출 판정. 서버(`QuizBankScope`)는 한국 초등 수학 조합만 받는다.
 * 국가 조건이 없던 동안 인니·태국 등 9개국 유저에게 열렸다(열람자의 67%).
 *
 * 한국 여부는 **유저 국가(`isKR`)와 카테고리 국가 두 축**으로 본다. 평상시엔 같은 값이지만
 * (빌드 정보 API 가 유저 국가로 카테고리 트리를 스코프한다) 각각 상대가 못 막는 경로가 있다.
 * - 유저 비한국 + 카테고리 `10…`: CREATE 기본값이 오는 `lastQuizSetCreationInfo` 는
 *   트리 검증(`useValidCategory`)을 안 거쳐서, 계정 국가가 바뀐 유저에게 남는다.
 * - 유저 한국 + 카테고리 비한국: 복제·수정이 원본 세트의 id 를 그대로 폼에 시드한다.
 *
 * categoryTreeId 자릿수 규약 (`views/build/util/schoolInfo.util.ts` 와 동일):
 * `[0,2)` 국가 · `[2,3)` 학교급 · `[3,5)` 학년 · `[5,7)` 과목
 */
export const isQuizBankSupported = (
  categoryTreeId: string | undefined,
  { isKR }: { isKR: boolean },
): boolean => {
  if (!isKR) return false;
  if (!categoryTreeId || categoryTreeId.length < 7) return false;
  return (
    categoryTreeId.slice(0, 2) === KOREA_CATEGORY &&
    categoryTreeId.slice(2, 3) === ELEMENTARY_SCHOOL_TYPE &&
    categoryTreeId.slice(5, 7) === MATH_SUBJECT
  );
};

/** 서버가 받는 7자리로 자른다. 폼의 `subSubject`(9자리)가 와도 안전하다. */
export const toQuizBankCategoryTreeId = (categoryTreeId: string) =>
  categoryTreeId.slice(0, 7);

/** 학년 코드(`'01'`~`'06'`). 앞단에서 고른 학년이 미리 적용된 필터가 된다. */
export const toQuizBankGradeCode = (categoryTreeId: string) =>
  categoryTreeId.slice(3, 5);

const ALL_GRADES_CODE = '99';

/**
 * 진입 시 radio 초기값. 전학년(`99`)은 서버가 받지 않으므로 `null`(전체)로 바꾼다 —
 * 그대로 보내면 200 + 빈 목록이라 원인이 드러나지 않는다.
 */
export const toQuizBankInitialGradeId = (
  categoryTreeId: string,
): string | null => {
  const grade = toQuizBankGradeCode(categoryTreeId);
  return grade === ALL_GRADES_CODE ? null : grade;
};
